import Footer from "../components/LandingScreenComponents/Footer";
import HeaderCompact from "../components/LandingScreenComponents/HeaderCompact";

const TermsOfUse = () => {
    return (
        <div className="flex flex-col px-4 pt-4 sm:px-6 lg:px-12">
        
        <HeaderCompact />
      <div className="w-[96%] md:w-[60%] mx-auto">
<div className="prose max-w-none text-gray-800">
  <h2 className="text-2xl font-bold mb-4">
    Terms of Service / End User License Agreement (EULA)
  </h2>
  <p className="mb-4">
    <strong>Effective Date:</strong> 09/15/2025<br />
    <strong>Entity Responsible:</strong> Kety, Inc.
  </p>

  <h3 className="text-lg font-semibold mb-2">1. Agreement</h3>
  <p className="mb-4">
    These Terms of Service (“Terms”) govern your use of Solvi. By using the App, you agree to these Terms.
  </p>

  <h3 className="text-lg font-semibold mb-2">2. License</h3>
  <p className="mb-4">
    We grant you a limited, non-exclusive, non-transferable license to use Solvi for personal, non-commercial purposes.
  </p>

  <h3 className="text-lg font-semibold mb-2">3. Subscriptions & Payments</h3>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li>1 Month: $22.99 USD</li>
    <li>3 Months: $34.99 USD</li>
    <li>12 Months: $79.99 USD</li>
  </ul>
  <p className="mb-2">All subscriptions are recurring unless canceled.</p>
  <p className="mb-4">Payments are processed through Apple App Store, Google Play, or Stripe.</p>

  <h3 className="text-lg font-semibold mb-2">4. Rewards Program (Solvi Stars)</h3>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li>Solvi Stars are loyalty points with no cash value.</li>
    <li>Earning Stars may allow participation in challenges and eligibility for rewards (e.g., beauty boxes).</li>
    <li>Rewards are not guaranteed and may be limited in availability.</li>
    <li>Kety, Inc. may change or discontinue rewards at any time.</li>
  </ul>

  <h3 className="text-lg font-semibold mb-2">5. User Content</h3>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li>Users may upload face photos (e.g., for leaderboard).</li>
    <li>You retain ownership of your content, but grant Solvi a license to use it for app functionality.</li>
    <li>You are responsible for ensuring your content does not infringe rights of others.</li>
  </ul>

  <h3 className="text-lg font-semibold mb-2">6. Disclaimers</h3>
  <p className="mb-4">
    Solvi provides cosmetic and wellness guidance only.<br />
    We do not provide medical advice. Consult a licensed physician or dermatologist for medical concerns.
  </p>

  <h3 className="text-lg font-semibold mb-2">7. Limitation of Liability</h3>
  <p className="mb-4">
    Solvi and Kety, Inc. are not liable for any damages resulting from use of the App. To the maximum extent permitted by law, our liability is limited to the amount you paid for the subscription in the 12 months prior to the claim.
  </p>

  <h3 className="text-lg font-semibold mb-2">8. Dispute Resolution</h3>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li><strong>Governing Law:</strong> Delaware, USA.</li>
    <li>Disputes will first be resolved through mediation.</li>
    <li>If unresolved, disputes shall be handled in Delaware courts.</li>
  </ul>

  <h3 className="text-lg font-semibold mb-2">9. Termination</h3>
  <p className="mb-4">
    We may suspend or terminate accounts that violate these Terms.
  </p>

  <h3 className="text-lg font-semibold mb-2">10. Contact</h3>
  <p className="mb-4">
    For all inquiries, please contact us at{" "}
    <a className="underline text-blue-600" href="mailto:support@solvi.club">
      support@solvi.club
    </a>
    .<br />
    We provide customer support only through email and do not offer phone or in-app live chat support.
  </p>

  <h3 className="text-lg font-semibold mb-2">11. Copyright & DMCA Policy</h3>
  <p className="mb-2">
    We respect the intellectual property rights of others and expect our users to do the same.
  </p>
  <p className="mb-2">
    If you believe that content available through Solvi infringes your copyright, you may submit a notification under the Digital Millennium Copyright Act (“DMCA”) by providing our Designated Copyright Agent with the following information in writing:
  </p>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li>Your physical or electronic signature;</li>
    <li>Identification of the copyrighted work you claim is infringed;</li>
    <li>Identification of the material that you claim is infringing, with sufficient detail for us to locate it;</li>
    <li>Your contact information (address, telephone number, and email);</li>
    <li>A statement that you have a good faith belief that the use of the material is not authorized by the copyright owner, its agent, or the law;</li>
    <li>A statement, under penalty of perjury, that the information in your notice is accurate and that you are authorized to act on behalf of the copyright owner.</li>
  </ul>
  <address className="not-italic mb-4">
    <strong>DMCA Agent Contact:</strong><br />
    Kety, Inc. – DMCA Agent<br />
    4705 Bayview Drive<br />
    Plano, TX 75093<br />
    Email:{" "}
    <a className="underline text-blue-600" href="mailto:support@solvi.club">
      support@solvi.club
    </a>
  </address>
  <p className="mb-4">
    Upon receipt of a valid DMCA notice, we will remove or disable access to the allegedly infringing content and may terminate accounts of repeat infringers.
  </p>

  <h3 className="text-lg font-semibold mb-2">Disclaimers</h3>
  <h4 className="text-md font-semibold mb-1">Wellness Disclaimer</h4>
  <p className="mb-4">
    Solvi provides skincare and wellness recommendations for cosmetic purposes only. Information in the App is not medical advice and should not be used to diagnose or treat medical conditions. Always consult a qualified healthcare provider for medical concerns.
  </p>
  <h4 className="text-md font-semibold mb-1">Rewards Disclaimer</h4>
  <p className="mb-4">
    Solvi Stars are virtual loyalty points without monetary value. Rewards such as beauty boxes are promotional, limited, and not guaranteed.
  </p>
</div>

      </div>
      <Footer />
        </div>
    )
};



export default TermsOfUse;